import { Car, Truck, Crown } from "lucide-react";
import { AnimatedSection, StaggerContainer, StaggerItem } from "@/components/AnimatedSection";

const segments = [
  { icon: Car, title: "Daily Drivers", desc: "Commuters, runabouts and everyday family cars — serviced and repaired to keep you on the road." },
  { icon: Car, title: "Family Cars & SUVs", desc: "Estates, people carriers and SUVs. School runs to weekends away — we keep them reliable." },
  { icon: Truck, title: "Vans & Commercials", desc: "Light commercial vehicles and work vans. Downtime costs money — we get you back out fast." },
  { icon: Crown, title: "Executive & Premium", desc: "Mercedes, BMW, Audi, Porsche and more. Quality care without dealer-level bills." },
];

export function VehicleTypes() {
  return (
    <AnimatedSection>
      <section className="py-16 md:py-20 bg-secondary">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">Built for Real Motorists</h2>
            <p className="mt-2 text-muted-foreground">From daily commuters to premium motors — all treated with the same care and attention.</p>
          </div>
          <StaggerContainer className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {segments.map((s) => (
              <StaggerItem key={s.title}>
                <div className="flex gap-4 p-5 rounded-xl border border-border bg-card hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/8 shrink-0">
                    <s.icon className="h-5.5 w-5.5 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-[15px] font-bold text-foreground">{s.title}</h3>
                    <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>
    </AnimatedSection>
  );
}
